/**
 * The string the user is typing and the number the form stores are not the same
 * thing: `"1."`, `"1.50"` and `"0."` all parse to a number that stringifies back
 * to something shorter. Rendering `String(value)` therefore eats the keystroke
 * that made the value a decimal. These two functions are the seam.
 */

/**
 * The form value a raw input string stands for. Empty — and any prefix that is
 * not yet a number at all (`"."`, `"-"`) — is `null`, never `NaN`: the consumer
 * schemas are `z.number().nullable()`, which `NaN` would slip past structurally
 * and then save as a corrupt value.
 */
export function parseDecimalInput(raw: string): number | null {
  if (raw === "") return null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
}

/**
 * What to show in the input. The user's own text wins for as long as it still
 * MEANS the value the form holds — that is what keeps `"1."` on screen while the
 * number is still 1. The moment the value changes from somewhere other than this
 * keystroke (a refetch, a reset, a different line item), the buffer no longer
 * means it and the incoming value takes over.
 */
export function resolveDecimalDisplay(
  buffer: string,
  value: number | null,
): string {
  if (parseDecimalInput(buffer) === value) return buffer;
  return value == null ? "" : String(value);
}
